import ConditionalWrapper from '@/components/ui/custom/ConditionalWrapper';
import { Tooltip } from '@/components/ui/custom/dataDisplay/Tooltip';
import Checkbox from '@/components/ui/custom/dataInput/Checkbox';
import { useTranslation } from 'react-i18next';

type Props = {
  id: string;
  disabled?: boolean;
  checked?: boolean;
  onChange(checked: boolean): void;
  editing?: boolean;
  loading?: boolean;
};

export default function ResourceMandatoryCheckbox(props: Props) {
  const { editing, disabled = false, loading, checked, onChange, id } = props;

  const { t: tResourceEditor } = useTranslation('translation', {
    keyPrefix: 'resourceEditor',
  });

  const { t: editRulesT } = useTranslation('translation', {
    keyPrefix: 'adminPage.editCourseRules',
  });

  return (
    <ConditionalWrapper
      condition={disabled}
      wrapper={
        <Tooltip
          text={editRulesT('cantModify')}
          className="h-fit"
          classNameContainer="flex items-center"
        />
      }
    >
      <Checkbox
        data-testid="mandatoryCheckbox"
        id={id}
        loading={loading}
        disabled={!editing || disabled}
        checked={checked}
        className={{
          div: 'flex-row-reverse h-fit shrink-0 top-1 relative',
          input: 'relative bottom-0.5',
        }}
        onChange={({ target }) => onChange(target.checked)}
        label={tResourceEditor('isMandatory')}
      />
    </ConditionalWrapper>
  );
}
